export default {"src":"/_next/static/media/facebook-fill.739d5934.svg","height":14,"width":14,"blurWidth":0,"blurHeight":0};